import { isEnglishUi } from './uiLocale'

function normalizeLabelKey(value: string): string {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s*\/\s*/g, '/')
    .replace(/\s+/g, ' ')
    .trim()
}

/** Etiquetas de menú / descripción que vienen del back en español. */
const CATALOG_LABEL_EN: Record<string, string> = {
  'brazo/respaldo': 'ARM/BACK',
  'brazo / respaldo': 'ARM/BACK',
  brazo: 'ARM',
  respaldo: 'BACK',
  base: 'BASE',
  cojines: 'CUSHIONS',
  cojin: 'CUSHION',
  'cojin / asiento': 'CUSHION / SEAT',
}

/**
 * Localiza etiquetas de catálogo/menú (BRAZO/RESPALDO, BASE, COJINES…).
 * En español se deja el texto original; en inglés se traduce si hay mapeo.
 */
export function localizeCatalogLabel(raw?: string): string {
  const value = String(raw || '').trim()
  if (!value) return ''
  if (!isEnglishUi()) return value

  const key = normalizeLabelKey(value)
  if (CATALOG_LABEL_EN[key]) return CATALOG_LABEL_EN[key]

  // "Brazo / Respaldo" con espacios variables
  const compact = key.replace(/\s+/g, '')
  if (CATALOG_LABEL_EN[compact]) return CATALOG_LABEL_EN[compact]

  // Traducción parcial por términos sueltos (p. ej. "BACK ALTURA 51", "BASE ALTURA 35").
  let text = value
  text = text.replace(/\bBRAZO\b/gi, 'ARM')
  text = text.replace(/\bRESPALDO\b/gi, 'BACK')
  text = text.replace(/\bCOJINES\b/gi, 'CUSHIONS')
  text = text.replace(/\bCOJÍN\b/gi, 'CUSHION')
  text = text.replace(/\bCOJIN\b/gi, 'CUSHION')
  text = text.replace(/\bALTURA\b/gi, 'HEIGHT')
  // BASE solo si es la palabra entera del label (evita "BASED").
  if (normalizeLabelKey(text) === 'base') return 'BASE'

  return text
}
